module.exports = __webpack_public_path__ + "static/img/campaign-box.c8db79e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/inventory/campaign-box.png
// module id = xM8E
// module chunks = 134